import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link, type LinkProps } from "react-router";

/** primary = white with black text (one per view); plain = outlined; text = no outline. */
export type ButtonVariant = "primary" | "plain" | "text";

const CLASS: Record<ButtonVariant, string> = { primary: "btn btn-pri", plain: "btn", text: "btn btn-txt" };

export function buttonClass(variant: ButtonVariant = "plain", extra?: string): string {
  return extra ? `${CLASS[variant]} ${extra}` : CLASS[variant];
}

export function Button({
  variant = "plain",
  className,
  type = "button",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant }) {
  return <button type={type} className={buttonClass(variant, className)} {...rest} />;
}

/** A link that looks like a button: for actions that go to another screen. */
export function LinkButton({
  variant = "plain",
  className,
  children,
  ...rest
}: LinkProps & { variant?: ButtonVariant; children: ReactNode }) {
  return (
    <Link className={buttonClass(variant, className)} {...rest}>
      {children}
    </Link>
  );
}
